import React from 'react';
import { getAppCfg } from './release/utils/common';
export const domainName = document._portalConfig.customer;
export const connection ={
    crmConfig : {
        cookiesConfig:{
            secure: false,
           // path: document._basePath,
           // sameSite: 'None',
            expires: 0
        },
        basename: document._portalConfig.basePath,
        publicPath: document._portalConfig.publicPath ,//set to /web or /uat when deploy
        defaultCrmServer: document._portalConfig.crmServer,
        isOpenPaypal: document._portalConfig.isOpenPaypal,
        paypalIntegration: document._portalConfig.paypalIntegration,
        secure: false,
        sslCertificates: ["pr6","hellenicbankcom","hellenic_prod"],
        isOpenFAC: document._portalConfig.isOpenFAC,
        facIntegration: document._portalConfig.facIntegration,
        isOpenStripe: document._portalConfig.isOpenStripe,
        stripeIntegration: document._portalConfig.stripeIntegration,
        apiKeyBackend: document._portalConfig.apiKeyBackend,
    }
}
export const portal_config = {
    apiKey:'AIzaSyASJk1hzLv6Xoj0fRsYnfuO6ptOXu0fZsc',
    webClientId: '89090741580-ecfsd2kfak4buvcldi699n5233aul8nd.apps.googleusercontent.com',
    default_currency: '€',
    copyright:'© CRM.COM',
    isLocationVN: false,

    airlink: {
        app_name: 'Airlink',
        logoStyle: 'square',
        logoDimension: {
            width: 100,
            height: 100,
        },
        isOfferFilter: true,
        isRegisterCountry: true,
        localLogo: false,
        landingPageLogo: true,
        usingLocalTheme: false,
        usingLocalIcon: false,
        landingPageBackgroundColor: false,
        referFriend: true,
        isCredentials: true,
        replaceIconWithFont: {
            home: false,
            offer: true
        },
        mainPageLocalColor: false,
        drawerLocalColor: true,
        headerLocalColor: true,
        textPriLocalColor: true,
        showMapHeader: false,        
        facIntegration: document._portalConfig.facIntegration,
        showInvoicePage: true,
        isShowServiceChanges: true,
    },
}

export const custom_assets = {
    airlink: {
        customIcon: false,
        customImage: {
            background: false,
            logo: false
        },
    },
    //buyway
    buyway:{
        customIcon: true,
        customImage:{
            background:true,
            logo:true
        },
    },
    coffeedirect: {
        customIcon: false,
        customImage: {
            background: false,
            logo: false
        },
    },
    coffeehouse:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    release:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    costacoffee:{
        customIcon: true,
        customImage:{
            background:true,
            logo:true
        },
    },
    checkin:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    cignal:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    ipharmcy:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    mikel:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    homespot:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    ventuno:{
        customIcon: false,
        customImage:{
            background:false,
            logo:false
        },
    },
    prestabist: {
        customIcon: false,
        customImage: {
            background: false,
            logo: false
        },
    },
}


export const address_types = [
    {
        label: "Home",
        value: 'HOME',
    },
    {
        label: "Business",
        value: 'BUSINESS',
    },
    {
        label: "Alternative",
        value: 'ALTERNATIVE'
    }
]

export const town_city = [
    {
        id: "All",
        name: 'All',//FAMAGUSTA
    },
    {
        id: "Famagusta",
        name: 'Famagusta',//FAMAGUSTA
    },
    {
        id: "Larnaca",
        name: 'Larnaca',//LARNACA
    },
    {
        id: "Limassol",
        name: 'Limassol',//LIMASSOL
    },
    {
        id: "Nicosia",
        name: 'Nicosia',//NICOSIA
    },
    {
        id: "Paphos",
        name: 'Paphos',//PAPHOS
    },
]